import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { TEMPLATE_METADATA_FIELDS } from '../../../core/services/template-metadata.service';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { ButtonComponent } from '../button/button.component';
import { ModalDialogComponent } from '../modal-dialog/modal-dialog.component';

/**
 * Help dialog listing the {{checkpoint.title}}-style placeholders available in
 * text-label content. Opened from the (i) button in the text-label content editor.
 */
@Component({
  selector: 'app-metadata-help-dialog',
  standalone: true,
  imports: [ModalDialogComponent, ButtonComponent, TranslatePipe],
  templateUrl: './metadata-help-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './metadata-help-dialog.component.css',
})
export class MetadataHelpDialogComponent {
  @Output() closed = new EventEmitter<void>();

  readonly metadataFields = TEMPLATE_METADATA_FIELDS;

  close(): void {
    this.closed.emit();
  }
}
